import { $apiWithoutClient } from 'modules/global';

import { IUserProfileInfo } from '../models';

export const getUserProfileInfo = (id?: string) => async () => {
  const { data } = await $apiWithoutClient.get<IUserProfileInfo>(`/profile/view${id ? `?id=${id}` : ''}`);

  return data;
};
